import React from "react";
import DataTableBase from "./dataTableBase";
import { brandColumns } from "./columnDefs";

export default function DeviceBrandsTable({ deviceBrands = [] }) {
  return (
    <DataTableBase
      title={"Device Brands"}
      data={deviceBrands}
      columns={brandColumns}
      orderby="time_created"
    />
  );
}
